import { useState } from 'react'
import mercadolibreService from '../../../services/mercadolibreService'
import { MercadoLibreOAuthResponse, MercadoLibreOAuthCallback } from '../types/mercadolibre'

export const useMercadoLibreOAuth = () => {
  const [authData, setAuthData] = useState<MercadoLibreOAuthResponse | null>(null)
  const [isLoading, setIsLoading] = useState(false)
  const [error, setError] = useState<string | null>(null)

  const getAuthUrl = async () => {
    try {
      setIsLoading(true)
      setError(null)
      const response = await mercadolibreService.getOAuthAuthUrl()
      setAuthData(response)
      return response
    } catch (err: any) {
      const errorMessage = err.response?.data?.message || 'Error al obtener URL de autorización'
      setError(errorMessage)
      return null
    } finally {
      setIsLoading(false)
    }
  }

  const processCallback = async (code: string): Promise<MercadoLibreOAuthCallback | null> => {
    try {
      setIsLoading(true)
      setError(null)
      const response = await mercadolibreService.processOAuthCallback(code)
      return response
    } catch (err: any) {
      const errorMessage = err.response?.data?.message || 'Error al procesar callback de OAuth'
      setError(errorMessage)
      return null
    } finally {
      setIsLoading(false)
    }
  }

  const openAuthWindow = (authUrl: string) => {
    const popup = window.open(
      authUrl,
      'mercadolibre-auth',
      'width=600,height=700,scrollbars=yes,resizable=yes'
    )

    // Escuchar el cierre de la ventana
    const checkClosed = setInterval(() => {
      if (popup?.closed) {
        clearInterval(checkClosed)
        // Aquí podrías verificar si se completó la autorización
        // y actualizar el estado correspondiente
      }
    }, 1000)

    return popup
  }

  const clearError = () => setError(null)

  return {
    authData,
    isLoading,
    error,
    getAuthUrl,
    processCallback,
    openAuthWindow,
    clearError
  }
}
